// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsData } from './EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsData.gen';
import type { EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsErrors } from './EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsErrors.gen';
import type { EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsResponses } from './EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsResponses.gen';
import type { EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationData } from './EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationData.gen';
import type { EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationErrors } from './EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationErrors.gen';
import type { EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationResponses } from './EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationResponses.gen';
import type { Options } from './Options.gen';

export class EshopCustomerAccountNotificationController {
    /**
     * Get customer account notifications
     */
    public static getCustomerAccountNotifications<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsResponses, EshopCustomerAccountNotificationControllerGetCustomerAccountNotificationsErrors, ThrowOnError>({ url: '/api/eshop/customer-account-notifications', ...options });
    }
    
    /**
     * Update customer account notifications
     */
    public static updateCustomerAccountNotification<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationResponses, EshopCustomerAccountNotificationControllerUpdateCustomerAccountNotificationErrors, ThrowOnError>({
            url: '/api/eshop/customer-account-notifications/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
